export interface ProjectRole {
  id: number;
  name: string;
  description?: string;
}

// ID 2 era PM (removido) — não reutilizar
export const ProjectRoleId = {
  PO: 1,
  GP: 3,
  Arquiteto: 4,
  Designer: 5,
  Dev: 6,
} as const;
